import { BiStore } from "react-icons/bi";

import { useAllIconStyles } from "./AllIcon.styles";

export const AllIcon = (): JSX.Element => {
    const classes = useAllIconStyles();

    return <BiStore className={classes.root} size={18} />;
};
